/*
 * pdp-bundler.js
 * --------------
 * The product page's bundler: the Buy 1 / Buy 2 / Buy 3+ cards (Option B,
 * ENG-2381), on the markup in snippets/pdp-bundler-tiers.liquid. It won the
 * `pdp-bundler` experiment (stopped 30 Oct 2026) and replaced the redesign's
 * original picker; the names are kept from the experiment.
 *
 * Owns the whole bundler: swatches, header pieces, cards, colour list and add
 * to cart. Loaded from <head> on the default product template only
 * (snippets/pdp-redesign-head.liquid), so it runs before the product
 * section's deferred scripts, the sticky footer among them.
 */
(function () {
  /* Not offered in the cards, even if it is unhidden in admin. */
  var EXCLUDED = ['technicaller clear'];
  /* Units added in Buy 2 / Buy 3+ start on this colour (ENG-2381). */
  var NEW_UNIT_COLOR = 'answer me aquamarine';

  function formatMoney(cents, format) {
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    if (format && format.indexOf('{{') !== -1) {
      return format.replace(/\{\{\s*[a-z_]+\s*\}\}/i, amount);
    }
    return '$' + amount;
  }

  function discountFor(n) {
    // The same ladder as the Koala automatic discount applied at checkout.
    return n >= 3 ? 10 : n === 2 ? 5 : 0;
  }

  function init() {
    var root = document.querySelector('[data-pdp-bundler]');
    var tiersEl = root && root.querySelector('[data-pdpb-tiers]');
    if (!tiersEl || tiersEl.dataset.pdpbReady === 'true') return;

    var optionTpl = root.querySelector('[data-pdp-options]');
    var unitTpl = tiersEl.querySelector('[data-pdpb-unit-template]');
    var bodyEl = tiersEl.querySelector('[data-pdpb-body]');
    var unitsEl = tiersEl.querySelector('[data-pdpb-units]');
    var addEl = tiersEl.querySelector('[data-pdpb-add]');
    var cta = tiersEl.querySelector('[data-pdpb-cta]');
    if (!optionTpl || !unitTpl || !bodyEl || !unitsEl || !addEl || !cta) return;

    var options = [].slice.call(optionTpl.content.querySelectorAll('[data-pdp-option]')).map(function (el) {
      return {
        color: el.dataset.color,
        label: el.dataset.label,
        variantId: el.dataset.variantId,
        price: parseInt(el.dataset.price, 10) || 0,
        hex: (el.dataset.colorHex || '').trim(),
        image: el.querySelector('img') ? el.querySelector('img').getAttribute('src') : '',
        limited: el.dataset.limited === 'true',
        disabled: el.hasAttribute('disabled')
      };
    }).filter(function (o) {
      return !o.disabled && EXCLUDED.indexOf(o.color) === -1;
    });
    if (!options.length) return;

    // The sticky bar reads the total and the struck original from these
    // (ENG-2394). They stay hidden on this button itself.
    var ctaPriceEl = cta.querySelector('[data-pdpb-cta-price]');
    var ctaWasEl = cta.querySelector('[data-pdpb-cta-was]');

    var ctaColors = {};
    (root.dataset.ctaColors || '').split(',').forEach(function (entry) {
      var bits = entry.split(':');
      var key = (bits[0] || '').trim().toLowerCase();
      if (!key || !bits[1]) return;
      ctaColors[key] = { bg: bits[1].trim(), fg: (bits[2] || '').trim() };
    });

    var moneyFormat = root.dataset.moneyFormat || '';

    function byColor(color) {
      return options.filter(function (o) { return o.color === color; })[0];
    }

    var wanted = (root.dataset.defaultColor || '').toLowerCase();
    var urlVariant = (location.search.match(/[?&]variant=(\d+)/) || [])[1];
    var fromUrl = urlVariant && options.filter(function (o) { return o.variantId === urlVariant; })[0];
    var initial = fromUrl || byColor(wanted) || options[0];
    var newUnit = byColor(NEW_UNIT_COLOR) || byColor(wanted) || options[0];

    /* State. `units` is what goes in the cart, one entry per Tin Can.
       `tier` is the open card: 1, 2 or 3 (3 = "Buy 3+"). `swatch` is the
       colour selected in the swatch row, which only drives Buy 1's unit. */
    var units = [initial];
    var tier = 1;
    var swatch = initial;

    /* ---- Tier rules (ENG-2381, "Color swatch interaction") ----------------
       - Buy 1 <- cards: the unit resets to the swatch colour.
       - Buy 1 -> Buy 2 / Buy 3+: every unit is aquamarine.
       - Buy 2 <-> Buy 3+: colours already picked are kept; only newly added
         units are aquamarine.
       - Removing units with x down to one keeps that unit's colour. */
    function selectTier(next) {
      if (next === tier) return;
      if (next === 1) {
        units = [swatch];
      } else if (tier === 1) {
        units = [];
        for (var i = 0; i < next; i++) units.push(newUnit);
      } else if (next === 2) {
        units = units.slice(0, 2);
      } else {
        while (units.length < 3) units.push(newUnit);
      }
      tier = next;
      closeList();
      render();
    }

    function removeUnit(i) {
      units.splice(i, 1);
      tier = Math.min(units.length, 3);
      closeList();
      render();
    }

    function addUnit() {
      units.push(newUnit);
      closeList();
      render();
    }

    /* ---- Colour list ------------------------------------------------------
       The list and the mobile drawer keep the redesign's original picker
       classes (.pdp-redesign-bundler__list, __option), styled in
       pdp-redesign.css. */
    var overlayEl = root.querySelector('[data-pdp-overlay]');
    var openIndex = null;
    var openEl = null;
    var drawerQuery = window.matchMedia('(max-width: 1023px)');

    function closeList() {
      if (openEl) openEl.remove();
      openEl = null;
      [].slice.call(unitsEl.querySelectorAll('[data-pdpb-unit]')).forEach(function (el) {
        el.classList.remove('is-active');
      });
      root.classList.remove('is-drawer-open');
      if (overlayEl) overlayEl.hidden = true;
      openIndex = null;
    }

    function openList(hostEl, index) {
      if (openIndex === index) { closeList(); return; }
      closeList();
      openIndex = index;
      hostEl.classList.add('is-active');
      root.classList.add('is-drawer-open');
      if (overlayEl) overlayEl.hidden = false;

      var list = document.createElement('div');
      list.className = 'pdp-redesign-bundler__list';
      list.setAttribute('role', 'listbox');
      list.setAttribute('aria-label', 'Pick your colors');

      var listHeading = document.createElement('p');
      listHeading.className = 'pdp-redesign-bundler__list-heading';
      listHeading.textContent = 'Pick your colors:';
      list.appendChild(listHeading);

      options.forEach(function (opt) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pdp-redesign-bundler__option';
        btn.setAttribute('role', 'option');
        btn.setAttribute('aria-selected', String(units[index] && units[index].color === opt.color));
        var chip = document.createElement('span');
        chip.className = 'pdp-redesign-bundler__slot-chip';
        if (opt.image) chip.style.backgroundImage = 'url("' + opt.image + '")';
        var text = document.createElement('span');
        text.textContent = opt.label;
        btn.appendChild(chip);
        btn.appendChild(text);
        if (opt.limited) {
          var badge = document.createElement('span');
          badge.className = 'pdp-redesign-bundler__limited-badge';
          badge.textContent = 'Limited edition';
          btn.appendChild(badge);
        }
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          // A unit's own dropdown changes only that unit, never the swatch.
          units[index] = opt;
          closeList();
          render();
        });
        list.appendChild(btn);
      });

      /* Below 1024 the list is a bottom drawer, mounted on <body> inside a
         wrapper that carries the slide-in. Some customers on iOS Safari saw the
         drawer open with its last colour (Later Alligator Lilac) missing, a
         blank row where it should be, while the same page drew all four
         everywhere we could test. Nested inside the unit row, the list was a
         fixed-position scroller that was also the animated element, inside a
         card that re-renders. WebKit has a history of failing to paint exactly
         that, so the drawer now owns none of those roles at once: the wrapper
         moves, the list scrolls, and neither sits inside the buy box. Desktop
         keeps the inline dropdown, which needs the row as its positioning host. */
      if (drawerQuery.matches) {
        var drawer = document.createElement('div');
        drawer.className = 'pdp-redesign-bundler__drawer';
        drawer.appendChild(list);
        document.body.appendChild(drawer);
        openEl = drawer;
      } else {
        hostEl.appendChild(list);
        openEl = list;
      }
    }

    /* ---- Render ------------------------------------------------------------ */

    var tierEls = [].slice.call(tiersEl.querySelectorAll('[data-pdpb-tier]'));
    var unitPrice = parseInt(tiersEl.dataset.unitPrice, 10) || initial.price;

    function render() {
      tierEls.forEach(function (el) {
        var open = parseInt(el.dataset.pdpbTier, 10) === tier;
        el.classList.toggle('is-open', open);
        var head = el.querySelector('[data-pdpb-tier-head]');
        if (head) head.setAttribute('aria-expanded', String(open));
        if (open && bodyEl.parentNode !== el) el.appendChild(bodyEl);

        var now = el.querySelector('[data-pdpb-now]');
        var pct = now ? parseInt(now.dataset.pct, 10) || 0 : 0;
        if (now) now.textContent = formatMoney(Math.round(unitPrice * (1 - pct / 100)), moneyFormat);
        var was = el.querySelector('[data-pdpb-was]');
        if (was) was.textContent = formatMoney(unitPrice, moneyFormat);
      });

      unitsEl.textContent = '';
      units.forEach(function (opt, i) {
        var frag = unitTpl.content.cloneNode(true);
        var row = frag.querySelector('[data-pdpb-unit]');
        frag.querySelector('[data-pdpb-unit-index]').textContent = i + 1 + '.';
        frag.querySelector('[data-pdpb-unit-label]').textContent = opt.label;
        var chip = frag.querySelector('[data-pdpb-unit-chip]');
        if (opt.image) chip.style.backgroundImage = 'url("' + opt.image + '")';

        var removeEl = frag.querySelector('[data-pdpb-unit-remove]');
        if (removeEl && i > 0) {
          removeEl.hidden = false;
          removeEl.addEventListener('click', function (e) {
            e.stopPropagation();
            removeUnit(i);
          });
        }

        row.setAttribute('role', 'button');
        row.setAttribute('tabindex', '0');
        row.addEventListener('click', function (e) {
          if (e.target.closest('.pdp-redesign-bundler__list')) return;
          openList(row, i);
        });
        row.addEventListener('keydown', function (e) {
          if ((e.key === 'Enter' || e.key === ' ') && e.target === row) {
            e.preventDefault();
            openList(row, i);
          }
        });
        unitsEl.appendChild(frag);
      });

      addEl.hidden = tier !== 3;

      var labelEl = cta.querySelector('[data-pdpb-cta-label]');
      if (labelEl && !adding) labelEl.textContent = 'Add ' + units.length + ' to cart';

      // Cart total and, once the multi-buy discount applies, the undiscounted
      // total, for the sticky bar. Same ladder the cards and Koala use.
      var gross = units.reduce(function (sum, o) { return sum + o.price; }, 0);
      var pctNow = discountFor(units.length);
      if (ctaPriceEl) ctaPriceEl.textContent = formatMoney(Math.round(gross * (1 - pctNow / 100)), moneyFormat);
      if (ctaWasEl) {
        ctaWasEl.textContent = formatMoney(gross, moneyFormat);
        ctaWasEl.hidden = pctNow === 0;
      }

      // The button takes the colour of the last unit, as drawn (green, lilac,
      // white for the three cards), from the cta_colors theme setting. Text
      // colour is explicit, not derived.
      var last = units[units.length - 1];
      var styling = last ? ctaColors[(last.color || '').toLowerCase()] : null;
      cta.style.backgroundColor = (last && last.hex) || (styling && styling.bg) || '';
      cta.style.color = (styling && styling.fg) || '';
    }

    /* ---- Swatches -----------------------------------------------------------
       They change the photos (the colorChange event pdp-main-banner.js
       listens for) and push a view_item. In Buy 1 the swatch also sets the
       unit. In Buy 2 / Buy 3+ it leaves every unit alone, because there it is
       unclear which unit it would mean. */
    function markSelectedSwatch(color) {
      [].slice.call(root.querySelectorAll('[data-pdp-swatch]')).forEach(function (b) {
        b.classList.toggle('is-selected', b.dataset.color === color);
        b.setAttribute('aria-pressed', String(b.dataset.color === color));
      });
    }

    markSelectedSwatch(initial.color);

    var SCROLL_MS = 700;
    var scrollAnim = null;

    function scrollToTop() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        window.scrollTo(0, 0);
        return;
      }
      var from = window.pageYOffset || document.documentElement.scrollTop;
      if (from <= 0) return;
      if (scrollAnim) cancelAnimationFrame(scrollAnim);
      var start = 0;
      var abort = function () {
        if (scrollAnim) cancelAnimationFrame(scrollAnim);
        scrollAnim = null;
        window.removeEventListener('touchstart', abort);
        window.removeEventListener('wheel', abort);
      };
      window.addEventListener('touchstart', abort, { passive: true });
      window.addEventListener('wheel', abort, { passive: true });
      var step = function (now) {
        if (!start) start = now;
        var t = Math.min(1, (now - start) / SCROLL_MS);
        var eased = 1 - Math.pow(1 - t, 3);
        window.scrollTo(0, Math.round(from * (1 - eased)));
        if (t < 1) scrollAnim = requestAnimationFrame(step);
        else abort();
      };
      scrollAnim = requestAnimationFrame(step);
    }

    [].slice.call(root.querySelectorAll('[data-pdp-swatch]')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        markSelectedSwatch(btn.dataset.color);
        document.dispatchEvent(new CustomEvent('colorChange', {
          detail: { color: btn.dataset.color }
        }));
        if (typeof window.tinCanPushViewItem === 'function') {
          window.tinCanPushViewItem(btn.dataset.variantId);
        }

        var picked = byColor(btn.dataset.color);
        if (picked) {
          swatch = picked;
          if (tier === 1) {
            units = [picked];
            render();
          }
        }

        if (window.matchMedia('(min-width: 1024px)').matches) return;
        var carousel = document.querySelector('.product-layout__carousel');
        if (!carousel) return;
        var box = carousel.getBoundingClientRect();
        if (box.height <= 0) return;
        var visible = Math.max(0, Math.min(box.bottom, window.innerHeight) - Math.max(box.top, 0));
        if (visible / box.height >= 0.5) return;
        scrollToTop();
      });
    });

    /* ---- Cards, add another, dismissal ------------------------------------ */

    tierEls.forEach(function (el) {
      var head = el.querySelector('[data-pdpb-tier-head]');
      if (head) {
        head.addEventListener('click', function () {
          selectTier(parseInt(el.dataset.pdpbTier, 10));
        });
      }
    });

    addEl.addEventListener('click', addUnit);

    document.addEventListener('click', function (e) {
      // The drawer is outside the unit row now, so a tap on its heading or
      // padding has to be ignored here explicitly.
      if (e.target.closest('[data-pdpb-unit], .pdp-redesign-bundler__drawer')) return;
      closeList();
    });
    if (overlayEl) overlayEl.addEventListener('click', closeList);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openIndex !== null) closeList();
    });

    /* ---- Add to cart ---------------------------------------------------------
       One XHR to /cart/add.js with a line per variant, tracking pushed on
       success, then straight to the cart with no delay (a delay lets Shopify's
       own product_added_to_cart pixel double-count; see
       docs/TRACKING_DATALAYER.md). XHR rather than fetch, which Koala's script
       used to wrap. The double-submit guard is ENG-1856; the bfcache reset is
       ENG-1870 (Safari restores the page with `adding` still true). */
    var adding = false;

    function setAdding(on) {
      adding = on;
      cta.classList.toggle('is-adding', on);
      var labelEl = cta.querySelector('[data-pdpb-cta-label]');
      if (on && labelEl) labelEl.textContent = 'Adding...';
      if (!on) render();
    }

    window.addEventListener('pageshow', function (e) {
      if (e.persisted && adding) setAdding(false);
    });

    cta.addEventListener('click', function () {
      if (adding) return;
      setAdding(true);

      var byId = {};
      units.forEach(function (o) { byId[o.variantId] = (byId[o.variantId] || 0) + 1; });
      var items = Object.keys(byId).map(function (id) {
        return { id: parseInt(id, 10), quantity: byId[id] };
      });
      window.TC_PDP_LAST_ATC = items;

      var xhr = new XMLHttpRequest();
      xhr.open('POST', '/cart/add.js');
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onload = function () {
        if (xhr.status >= 400) { setAdding(false); return; }
        if (typeof window.tinCanPushAddToCart === 'function') {
          window.tinCanPushAddToCart(items);
        }
        var locale = window.location.pathname.match(/^\/(en-us|en-ca|en-au|en-nz|en-gb)/i);
        window.location.href = locale ? '/' + locale[1] + '/cart' : '/cart';
      };
      xhr.onerror = function () { setAdding(false); };
      xhr.send(JSON.stringify({ items: items }));
    });

    /* ---- Header pieces --------------------------------------------------------
       The tagline goes directly after the title and the badge beside the
       price, in flash-forward's title block: a sibling subtree, so CSS can't
       place them. */
    var headerTpl = root.querySelector('[data-pdp-header]');
    if (headerTpl) {
      var frag = headerTpl.content.cloneNode(true);
      var tagline = frag.querySelector('[data-pdp-tagline]');
      var badge = frag.querySelector('[data-pdp-badge]');
      var title = document.querySelector('.flash-forward__title');
      if (tagline && title && title.parentNode) title.parentNode.insertBefore(tagline, title.nextSibling);
      var subtitle = document.querySelector('.flash-forward__subtitle');
      if (badge && subtitle) subtitle.appendChild(badge);
    }

    tiersEl.dataset.pdpbReady = 'true';
    root.dataset.pdpBundlerReady = 'true';
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
